module.exports = __webpack_public_path__ + "e474b37fdd9d519e3ef01bebef2b3e45.jpg";